import { FormEvent, useEffect } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { Button } from '../Form/Button';
import { ContentCard } from '../ContentCard/ContentCard';
import './EditableCard.css';

type SimpleEditableCardProps = {
	title: string;
	onSubmit: () => Promise<boolean | void> | (boolean | void);
	renderWhenOpen: () => JSX.Element;
	renderWhenClosed: () => JSX.Element;
	alwaysOpen?: boolean;
	shouldStartOpen?: boolean;
	setOpen: (open: boolean) => void;
	open: boolean;
	cardId?: string;
};
export function SimpleEditableCard({
	title,
	onSubmit,
	alwaysOpen = false,
	shouldStartOpen = false,
	renderWhenOpen,
	renderWhenClosed,
	setOpen,
	open,
	cardId,
}: SimpleEditableCardProps): JSX.Element {
	const t = useTranslation().generic;

	useEffect(() => {
		if (shouldStartOpen) {
			setOpen(true);
		}
	}, [shouldStartOpen]);

	function handleSubmit(e: FormEvent) {
		e.preventDefault();
		const success = onSubmit();
		if (success || success === undefined) {
			setOpen(false);
		}
	}

	return (
		<div onClick={open ? () => {} : () => setOpen(true)} id={cardId}>
			<ContentCard className="editable-card" title={title}>
				{!open && (
					<>
						<Button className={`secondary ${'card-edit-button-absolute'}`} onClick={() => setOpen(true)}>
							{t.edit}
						</Button>
						{renderWhenClosed()}
					</>
				)}
				{open && (
					<form onSubmit={handleSubmit}>
						{renderWhenOpen()}

						{!alwaysOpen && (
							<div className="card-footer">
								<Button onClick={handleSubmit}>{t.save}</Button>
								<Button onClick={() => setOpen(false)} className="secondary">
									{t.cancel}
								</Button>
							</div>
						)}
					</form>
				)}
			</ContentCard>
		</div>
	);
}
